import React from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';
import SubNav from './SubNav';
import Footer from '../Footer';
import ShoppingBag from '../ShoppingBag';
import { useNavigate } from 'react-router-dom';
import CookieConsent from '../common/CookieConsent';

const AppLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Helper to determine active view for AppHeader highlighting
  // Paths: /shop, /uniform, /artifacts, /vault, /profile
  const currentView = location.pathname === '/' ? 'home'
    : location.pathname.substring(1).split('/')[0];

  // Determine SubNav items based on current section
  const getSubNavItems = () => {
    const path = location.pathname;

    // Shop Section (everything available / the fragment record / surfacing soon)
    if (path.startsWith('/shop') || path.startsWith('/fragments')) {
      return [
        { label: 'ALL', path: '/shop' },
        { label: 'FRAGMENTS', path: '/fragments' },
        { label: 'SURFACING SOON', path: '/shop/soon' }
      ];
    }

    // Profile Section
    if (path.startsWith('/profile')) {
      return [
        { label: 'CLUB', path: '/profile' },
        { label: 'ORDERS', path: '/profile/orders' },
        { label: 'SETTINGS', path: '/profile/settings' }
      ];
    }

    return [];
  };

  const subNavItems = getSubNavItems();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Hide Header/Footer for Admin routes if necessary, though Admin has its own layout */}
      {!location.pathname.startsWith('/admin') && (
        <>
          <AppHeader currentView={currentView} />
          {subNavItems.length > 0 && <SubNav items={subNavItems} />}
          <ShoppingBag />
        </>
      )}

      <main className="flex-grow">
        <Outlet />
      </main>

      {!location.pathname.startsWith('/admin') && (
        <>
          <Footer />
          <CookieConsent />
        </>
      )}
    </div>
  );
};

export default AppLayout;
